import { get, post, patch, del } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/companies`;

export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`${base(wsId)}${q}`);
};

export const getOne = (wsId, companyId) => get(`${base(wsId)}/${companyId}`);
export const create = (wsId, body) => post(base(wsId), body);
export const update = (wsId, companyId, body) => patch(`${base(wsId)}/${companyId}`, body);
export const remove = (wsId, companyId) => del(`${base(wsId)}/${companyId}`);
export const archive = (wsId, companyId) => post(`${base(wsId)}/${companyId}/archive`);
